var VehiclePicker = class extends HTMLElement {
  constructor() {
    super();

    this.init();

    window.addEventListener("vehicleCleared", e => {
      this.init();
    });
  }

  init() {

    if(!VehicleData){
      location.reload();
    }

    VehicleData.init();

    const initialVehicle = VehicleData.getSelectedVehicle();
    this.innerHTML = '';

    if (initialVehicle) {
      this.make = initialVehicle.make;
      this.model = initialVehicle.model;
      this.year = initialVehicle.year;
    } else {
      this.make = null;
      this.model = null;
      this.year = null;

      // Hide ATC PDP if no Vehicle Selected (it's unhidden on vehicleSelected event listener on VpvBuyButtons)
      document.querySelector('.product-info vpv-buy-buttons')?.setAttribute('hidden', '');
    }

    this.vehicleJsonData = null;
    this.visible = true;

    this.makes = [];
    this.foundProducts = [];

    this.systemProductHandle = this.getAttribute("system-product-handle");
    this.systemProductTitle = this.getAttribute("system-product-title");

    this.mode = this.getAttribute("mode");

    const $top = document.createElement("div");
    $top.classList.add('vehiclePicker__selects__top');

    const $title = document.createElement("div");
    $title.classList.add('vehiclePicker__selects__title');
    $title.innerText = "Find Your Vehicle";

    const $clearAll = document.createElement("a");
    $clearAll.innerText = "Clear all";
    $clearAll.classList.add("clear-all", "link", "link-sm");
    $clearAll.addEventListener("click", () => {
      this.clearAll();
    });

    $top.appendChild($title);
    $top.appendChild($clearAll);

    this.$container = document.createElement("div");
    this.$container.classList.add("vehiclePicker__container");
    this.$container.classList.add(`mode--${this.mode}`);

    this.$container.addEventListener("click", () => {
      if (this.mode == "modal") this.close();
    });

    const $selects = document.createElement("div");
    $selects.classList.add("vehiclePicker__selects");

    $selects.appendChild($top);

    const previewFile = window.localStorage.getItem('vehicleDataPreviewFile');
    if(previewFile){
      const $preview = document.createElement("div");
      $preview.classList.add('vehiclePicker__selects__preview', 'banner', 'banner--warning', 'banner--with-button');
      $preview.innerHTML = `<p>Previewing <span>${previewFile}</span> </p><a href="?vp-preview=null" class="button button--sm" id="vehicleDataPreviewClear">Clear</a>`;
      $selects.appendChild($preview);
    }

    $selects.addEventListener("click", ev => {
      ev.stopPropagation();
      this.collapseAllSelects();
    });

    // Create select elements
    this.makeSelect = this.createSelect("make");
    this.modelSelect = this.createSelect("model");
    this.yearSelect = this.createSelect("year");

    this.$error = document.createElement("div");
    this.$error.classList.add("JSONDataError");

    this.$shopNowButton = document.createElement("button");
    this.$shopNowButton.classList.add("button", "button--shop-now");
    this.$shopNowButton.setAttribute("disabled", "disabled");
    this.$shopNowButton.innerHTML = 'SHOP NOW';

    if (this.mode == "modal") {
      const $close = document.createElement("a");
      $close.classList.add("close");
      $close.setAttribute("href", "#");
      $close.innerHTML = `<svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L21 21" stroke="currentColor" stroke-width="2"/><path d="M21 1L1 21" stroke="currentColor" stroke-width="2"/></svg> `;

      $close.addEventListener("click", ev => {
        ev.stopPropagation();
        ev.preventDefault();
        this.close();
        return false;
      });

      $selects.appendChild($close);
    }

    this.$shopNowButton.addEventListener("click", () => {
      if (this.foundProducts.length > 0) {
        this.close();

        VehicleData.selectVehicle({
          make: this.make,
          model: this.model,
          year: this.year
        });

        const vehicleSubmittedEvent = new CustomEvent("vehicleSubmitted", {
          detail: {
            make: this.make,
            model: this.model,
            year: this.year
          },
          bubbles: true,
          cancelable: true,
          composed: false,
        });

        this.dispatchEvent(vehicleSubmittedEvent);

      } else {
        alert("This product does not fit your selection.");
      }
    });

    $selects.appendChild(this.makeSelect);
    $selects.appendChild(this.modelSelect);
    $selects.appendChild(this.yearSelect);
    $selects.appendChild(this.$shopNowButton);

    $selects.appendChild(this.$error);

    this.$container.appendChild($selects);

    this.appendChild(this.$container);

    // Add a click event listener to the button to toggle the section's visibility
    //button.addEventListener('click', () => {
    //  section.style.display = section.style.display === 'none' ? 'block' : 'none';
    //});


    window.addEventListener("click", () => {
      this.collapseAllSelects();
    });

  }

  collapseAllSelects(){
    this.makeSelect.classList.remove("on");
    this.modelSelect.classList.remove("on");
    this.yearSelect.classList.remove("on");
  }

  createSelect(selectID) {
    const $select = document.createElement("div");
    const $ul = document.createElement("ul");
    const $button = document.createElement("button");

    $select.classList.add("select");

    $select.setAttribute("id", `${selectID}-select`);

    $button.innerHTML = `<span>${selectID}</span><svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 1.76514L8 7.23506L2 1.76514" stroke="currentColor" stroke-width="3"/>
    </svg>
    `;

    $button.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggleSelectOptions($select);
    });

    $select.appendChild($button);
    $select.appendChild($ul);

    return $select;
  }

  changeVehicle() {
    this.open();
  }

  resetMake() {
    this.make = "";
    this.makeSelect.querySelector("button span").innerText = "Make";
    this.makeSelect.classList.remove("on");
    // this.makeSelect.querySelector('ul').innerHTML = '';
  }

  resetModel() {
    this.model = "";
    this.modelSelect.querySelector("button span").innerText = "Model";
    this.modelSelect.querySelector("ul").innerHTML = "";
    this.modelSelect.classList.remove("on");
  }

  resetYear() {
    this.year = "";
    this.yearSelect.querySelector("button span").innerText = "Year";
    this.yearSelect.querySelector("ul").innerHTML = "";
    this.yearSelect.classList.remove("on");
  }

  toggleSelectOptions($select) {

    if ($select.querySelectorAll("li").length > 0) $select.classList.toggle("on");

    if (!$select.isEqualNode(this.makeSelect)) this.makeSelect.classList.remove("on");
    if (!$select.isEqualNode(this.modelSelect)) this.modelSelect.classList.remove("on");
    if (!$select.isEqualNode(this.yearSelect)) this.yearSelect.classList.remove("on");

  }

  clearAll() {
    this.resetMake();
    this.resetModel();
    this.resetYear();

    this.$shopNowButton.setAttribute("disabled", "disabled");
    this.close();
    VehicleData.reset();
    window.dispatchEvent(
      new CustomEvent("vehiclePickerReset", {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  open() {
    if (this.mode == "modal") document.querySelector('html').classList.add('lock');
    this.$container.classList.add(`opened`);
    this.querySelector("div.vehiclePicker__selects").style.display = "block";

    window.dispatchEvent(
      new CustomEvent("vehiclePickerOpened", {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  close() {
    this.hideSelects();
    document.querySelector('html').classList.remove('lock');
    this.$container.classList.remove(`opened`);

    window.dispatchEvent(
      new CustomEvent("vehiclePickerClosed", {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  hideSelects() {
    this.querySelector("div.vehiclePicker__selects").style.display = "none";
  }

  select(option, value) {
    if (option == "make") {
      this.resetModel();
      this.resetYear();

      const makeId = value;
      this.make = makeId;

      this.foundProducts = [];

      const makeModels = this.searchModelsByMake(makeId);
      this.modelOptions(makeModels);
      this.yearOptions([]);

      // modelSelect.dispatchEvent(new Event('change'));
      this.$shopNowButton.setAttribute("disabled", "disabled");

      this.makeSelect.classList.remove("on");
      this.makeSelect.querySelector("button span").innerText = `${value}`;
      if (makeModels.length>0) this.modelSelect.classList.add("on");
    } else if (option == "model") {
      this.resetYear();

      this.foundProducts = [];

      const modelId = value;
      this.model = modelId;

      // Populate the year dropdown with the options for the selected model
      const modelYears = this.searchYearsByMakeModel(this.make, modelId).sort((a, b) => b - a);
      this.yearOptions(modelYears);

      this.$shopNowButton.setAttribute("disabled", "disabled");

      this.modelSelect.classList.remove("on");
      this.modelSelect.querySelector("button span").innerText = `${value}`;
      if (modelYears.length>0) this.yearSelect.classList.add("on");
    } else if (option == "year") {
      this.year = value;

      const products = this.searchProductsByMakeModelYear(this.make, this.model, this.year);


      this.yearSelect.classList.remove("on");
      this.yearSelect.querySelector("button span").innerText = `${value}`;

      if (products.length > 0) {
        this.foundProducts = products;
        this.$shopNowButton.removeAttribute("disabled");
      } else {
        this.$shopNowButton.setAttribute("disabled", "disabled");
      }
    }
  }

  // Define the component's markup and styling
  connectedCallback() {

    if(window.__VPV.pdp.vehicleJsonReady){
      this.setupSelectOptions(window.__VPV.vehicleData.byTemplate);
    }

    // Load the data from the JSON file
    window.addEventListener("vehicleJsonReady", e => {
      this.setupSelectOptions(e.detail);
    });
  }

  makeOptions(data) {
    const makeSelect = this.makeSelect;

    const $ul = makeSelect.querySelector("ul");
    $ul.innerHTML = "";

    this.makes = [];

    // in reverse order so anything not in the list drops to the end
    const order = ["Mercedes Benz (all Sprinters)", "Sprinter Van", "Jeep Trucks", "Jeep", "Nissan", "GMC", "Toyota", "Ram",  "Chevy", "Ford"];

    const compare = (a, b) => {
      const indexA = order.indexOf(a.make);
      const indexB = order.indexOf(b.make);
      if (indexA < indexB) {
        return 1;
      } else if (indexA > indexB) {
        return -1;
      } else {
        return 0;
      }
    };

    const sortedData = data.sort(compare);


    sortedData.forEach(make => {
      if (this.makes.includes(make.make)) return;
      const option = document.createElement("li");
      option.setAttribute("data-value", make.make);

      option.addEventListener("click", e => {
        this.select("make", make.make);
        e.stopPropagation();
      });

      option.value = make.make;
      option.textContent = make.make;

      $ul.appendChild(option);
      this.makes.push(make.make);
    });
  }

  modelOptions(data) {
    const modelSelect = this.modelSelect;

    const $ul = modelSelect.querySelector("ul");
    $ul.innerHTML = "";

    const containsVanOrService = str => str.includes("Van") || str.includes("Service");

    data.sort((a, b) => {
      if (containsVanOrService(a) && !containsVanOrService(b)) {
        return 1;
      } else if (!containsVanOrService(a) && containsVanOrService(b)) {
        return -1;
      } else {
        return a.localeCompare(b);
      }
    });

    data.forEach(model => {
      const option = document.createElement("li");
      option.setAttribute("data-value", model);
      option.textContent = model;

      option.addEventListener("click", ev => {
        this.select("model", model);
        ev.stopPropagation();
      });

      $ul.appendChild(option);
    });
  }

  yearOptions(data) {
    const yearSelect = this.yearSelect;

    const $ul = yearSelect.querySelector("ul");
    $ul.innerHTML = "";

    data.forEach(year => {
      const option = document.createElement("li");
      // if (currentYear == year) option.setAttribute('selected', 'selected')
      option.value = year;
      option.textContent = year;

      option.addEventListener("click", ev => {
        this.select("year", year);
        ev.stopPropagation();
      });

      $ul.appendChild(option);
    });
  }

  setupSelectOptions(allVehicleObjs) {

    if (VehicleData.getSelectedVehicle() && this.mode !== 'section') {
      this.hideSelects();
    }

    this.vehicleJsonData = allVehicleObjs;
    this.makeOptions(this.vehicleJsonData);
  }

  disconnectedCallback() {
    // this._abortController.abort();
  }

  searchModelsByMake(make) {
    //const filteredData = this.vehicleJsonData.filter(item => item.make.toLowerCase() === make.toLowerCase());
    //const models = filteredData.map(item => item.model);
    //return models

    let models = [];
    for (let item of this.vehicleJsonData) {
      if (item.make === make) {
        if (!models.includes(item.model)) {
          models.push(item.model);
        }
      }
    }
    return models;
  }

  searchYearsByMakeModel(make, model) {
    //const filteredData = this.vehicleJsonData.filter(item => item.make.toLowerCase() === make.toLowerCase());
    //const models = filteredData.map(item => item.model);
    //return models

    let years = [];
    for (let item of this.vehicleJsonData) {
      if (item.make === make && item.model === model) {
        if (!years.includes(item.year)) {
          years.push(item.year);
        }
      }
    }
    return years;
  }

  searchProductsByMakeModelYear(make, model, year) {

    const vehicleObjects = VehicleData.searchVehicle({
      make: make,
      model: model,
      year: year,
    })

    return vehicleObjects;
  }

  customSelectDropdown(selectElement) {
    // Hide the original select element
    selectElement.style.display = "none";

    // Create a custom container element for the dropdown
    const container = document.createElement("div");
    container.classList.add("custom-select");

    // Create a custom display element for the selected option
    const display = document.createElement("div");
    display.classList.add("custom-select-display");

    // Add the initial selected option to the display element
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    display.innerText = selectedOption.innerText;

    // Create a custom options list element for the dropdown
    const optionsList = document.createElement("ul");
    optionsList.classList.add("custom-select-options");

    // Add each option from the original select element to the custom options list
    for (let i = 0; i < selectElement.options.length; i++) {
      const option = selectElement.options[i];
      const li = document.createElement("li");
      li.innerText = option.innerText;
      li.addEventListener("click", () => {
        // Update the display element with the selected option
        display.innerText = option.innerText;

        // Update the original select element with the selected option
        selectElement.value = option.value;
      });
      optionsList.appendChild(li);
    }

    // Add the display and options list elements to the container
    container.appendChild(display);
    container.appendChild(optionsList);

    // Add the container to the DOM
    selectElement.parentNode.insertBefore(container, selectElement.nextSibling);
  }
};

if (!window.customElements.get("vehicle-picker")) {
  window.customElements.define("vehicle-picker", VehiclePicker);
}

export { VehiclePicker };
